"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptNotification = exports.dismissNotification = exports.markNotificationAsUnread = exports.markNotificationAsRead = exports.updateNotification = exports.getUnreadNotificationsCount = exports.getOutageNotifications = exports.getNotifications = void 0;
var getNotifications_1 = __importDefault(require("./getNotifications"));
exports.getNotifications = getNotifications_1.default;
var getOutageNotifications_1 = __importDefault(require("./getOutageNotifications"));
exports.getOutageNotifications = getOutageNotifications_1.default;
var getUnreadNotificationsCount_1 = __importDefault(require("./getUnreadNotificationsCount"));
exports.getUnreadNotificationsCount = getUnreadNotificationsCount_1.default;
var updateNotification_1 = __importDefault(require("./updateNotification"));
exports.updateNotification = updateNotification_1.default;
var markNotificationAsRead_1 = __importDefault(require("./markNotificationAsRead"));
exports.markNotificationAsRead = markNotificationAsRead_1.default;
var markNotificationAsUnread_1 = __importDefault(require("./markNotificationAsUnread"));
exports.markNotificationAsUnread = markNotificationAsUnread_1.default;
var dismissNotification_1 = __importDefault(require("./dismissNotification"));
exports.dismissNotification = dismissNotification_1.default;
var acceptNotification_1 = __importDefault(require("./acceptNotification"));
exports.acceptNotification = acceptNotification_1.default;
